// extracted by mini-css-extract-plugin
export var banner = "_r5-0";
export var settingRow = "_r5-2";
export var titleIcon = "_r5-1";